import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useRef } from "react";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  Button,
  handleSubmitClick,
  ErrorList,
  Progressbar,
  RadioGroupForm,
  Heading,
} from "@ogt/ui";

export const DELAY_20_39_MINUTES = "delay_20_39_minutes";
export const DELAY_40_59_MINUTES = "delay_40_59_minutes";
export const DELAY_OVER_60_MINUTES = "delay_over_60_minutes";

export default function Delay() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 20;

  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });
          navigate("/betalningssatt");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          delay: Yup.string().test(
            "at-least-one-radio-selected",
            "Vänligen välj ett svarsalternativ för att gå vidare till nästa steg",
            (value) => {
              return (
                value === DELAY_20_39_MINUTES ||
                value === DELAY_40_59_MINUTES ||
                value === DELAY_OVER_60_MINUTES
              );
            }
          ),
        })}
      >
        {({ errors }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form noValidate>
              <Box>
                <Heading
                  progress={progress}
                  headingRef={h2Ref}
                  focusable
                  id="delay"
                >
                  Hur stor blev förseningen?
                </Heading>

                {Object.keys(errors).length > 0 && (
                  <ErrorList errors={errors} />
                )}
                <div
                  role="radiogroup"
                  aria-labelledby="delay"
                  className="radio-group"
                >
                  {errors.delay && (
                    <span
                      aria-describedby="forMe forOther"
                      className="validation-error"
                    >
                      {errors.delay.toString()}
                    </span>
                  )}

                  <div className={errors.delay ? "has-error" : ""}>
                    <RadioGroupForm
                      name="delay"
                      ariaLabelledBy="delay"
                      orientation="vertical"
                      variant="box"
                      options={[
                        {
                          id: "delay2039",
                          value: DELAY_20_39_MINUTES,
                          label: "Jag blev 20 - 39 minuter försenad",
                        },
                        {
                          id: "delay4059",
                          value: DELAY_40_59_MINUTES,
                          label: "Jag blev 40 - 59 minuter försenad",
                        },
                        {
                          id: "delayOver60",
                          value: DELAY_OVER_60_MINUTES,
                          label: "Jag blev minst 60 minuter försenad",
                        },
                      ]}
                    />
                  </div>
                </div>
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button onClick={handleSubmitClick(formRef)} type="submit">
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
